import { atom } from "@reatom/core"

import { SlugMeta } from "modules/PsyCatalog/common/Filters/UrlBuilder"
import { getSubRoutes, CATALOG_PATH } from "modules/PsyCatalog/common/utils"
import { CurrentFilter } from "modules/PsyCatalog/common/services/currentFilter"
import { citiesSlugsAtom } from "modules/PsyCatalog/common/models/cities/citiesSlugsAtom"
import { competencesSlugsAtom } from "modules/PsyCatalog/common/models/competences/competencesSlugsAtom"
import { methodsSlugsAtom } from "modules/PsyCatalog/common/models/methods/methodsSlugsAtom"
import { isBrowser } from "utils/infrastructure/ssg-utils"

const defaultMeta: SlugMeta = {
    slug: null,
    value: "",
    kind: "city",
    h1: "Подбор психолога",
}

export const pageMetaAtom = atom((ctx) => {
    let result = defaultMeta
    if (!isBrowser()) return result
    const bySlug = {
        cities: ctx.get(citiesSlugsAtom),
        methods: ctx.get(methodsSlugsAtom),
        competences: ctx.get(competencesSlugsAtom),
    }
    const { routes } = getSubRoutes(location.pathname)
    const filter = CurrentFilter.get()
    const city = bySlug.cities.get(filter)
    const method = bySlug.methods.get(filter)
    const competence = bySlug.competences.get(filter)
    result = city || method || competence || defaultMeta
    if (routes.path === CATALOG_PATH.online) {
        result.h1 = "Консультация психолога онлайн"
    }
    return result
})
